module.exports = __webpack_public_path__ + "static/media/Mask group.de5d49ee.svg";